export default "__VITE_ASSET__Do_YMO0L__"